import { LANG_PARAM, REFINE_PARAM } from "./constants.js";
const combineSearchParams = (newURL, oldURL) => {
  var _a, _b;
  let prevUrl;
  let url;
  try {
    prevUrl = new URL(oldURL);
  } catch (e) {
    console.error(e);
    return newURL;
  }
  try {
    url = new URL(newURL);
  } catch {
    const queryparams = newURL.split("?")[1];
    const newURLPlaceholder = [
      prevUrl.origin,
      prevUrl.pathname !== "/" ? prevUrl.pathname : "",
      queryparams ? `?${queryparams}` : ""
    ].join("");
    try {
      url = new URL(newURLPlaceholder);
    } catch (e) {
      console.error(e);
      return newURL;
    }
  }
  if (((_a = url == null ? void 0 : url.searchParams) == null ? void 0 : _a.get(LANG_PARAM)) && ((_b = prevUrl == null ? void 0 : prevUrl.searchParams) == null ? void 0 : _b.get(REFINE_PARAM))) {
    prevUrl.searchParams.delete(REFINE_PARAM);
  }
  const combinedParams = new URLSearchParams({
    ...Object.fromEntries((prevUrl == null ? void 0 : prevUrl.searchParams) || []),
    ...Object.fromEntries((url == null ? void 0 : url.searchParams) || [])
  });
  const size = new Set(combinedParams.keys()).size;
  if (size > 0) {
    return `${url.origin}${url.pathname !== "/" ? url.pathname : ""}?${combinedParams.toString()}`;
  }
  return url.toString();
};
export {
  combineSearchParams
};
